const API_ROOT_URL = process.env.VUE_APP_API_ROOT_URL;
const API_APP_FRONTEND = process.env.VUE_APP_FRONTEND_ROOT_URL;

const http = {
   server: API_ROOT_URL,
   front: API_APP_FRONTEND
};

export { http };
